import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowRight, Loader2 } from "lucide-react";
import { useAdminAuth } from "../lib/adminAuth";
import { Logo } from "../components/Logo";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setError("");
    setLoading(true);
    try {
      await login(password);
      navigate("/admin");
    } catch (err) {
      setError(err.message === "unauthorized" ? "Mot de passe incorrect" : err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain bg-ink text-white min-h-screen flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm"
      >
        <div className="flex flex-col items-center text-center mb-10">
          <Logo className="h-[44px]" />
          <p className="mt-4 text-xs uppercase tracking-[0.3em] text-accent-yellow">Espace privé</p>
        </div>

        <form onSubmit={submit} className="rounded-3xl border border-white/10 bg-white/[0.03] p-8" data-testid="admin-login-form">
          <label className="block text-xs uppercase tracking-[0.25em] text-white/45 mb-3">Mot de passe</label>
          <div className="relative">
            <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              data-testid="admin-password-input"
              placeholder="••••••••"
              className="w-full rounded-xl bg-ink border border-white/12 pl-11 pr-4 py-3 text-sm text-white placeholder:text-white/20 focus:border-accent-yellow focus:outline-none transition-colors"
            />
          </div>

          {error && (
            <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="group mt-6 w-full inline-flex items-center justify-center gap-3 px-7 py-3.5 rounded-xl bg-accent-yellow text-ink text-sm font-semibold hover:bg-white transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : (
              <>
                Se connecter
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </>
            )}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
